<template>
	<div class="page_content">
		<h3>新增规则</h3>
		<a-divider />
		<div class="page_edit_content">
			<a-form :form="form" :label-col="{ span: 2 }" :wrapper-col="{ span: 8 }">
				<div>
					<h4 v-if='$route.query.id'>驻场ID：{{$route.query.id}}</h4>
					<div>
						<h4>基础信息</h4>
						<a-form-item required label="驻场人员">
							<span>{{select_user.username}}</span>
							<a-button class="ml12" type="primary" html-type="submit" @click='add_user'>
								选择人员
							</a-button>
						</a-form-item>
						<a-form-item v-if='form.uid&&select_user.department_join' label="所属部门与职务">
							<p v-for="(it,itindex) in select_user.department_join.department_list">部门：{{it}}
								岗位：{{select_user.department_join.role_name[itindex]}}</p>
						</a-form-item>
						<a-form-item required label="分管领导">
							<span>{{leader_name}}</span>
							<a-button class="ml12" type="primary" html-type="submit" @click='leaderFactory=true'>
								选择分管领导
							</a-button>
						</a-form-item>
					</div>
				</div>

				<a-divider />
				<h4>当前工厂驻场打卡规则</h4>
				<a-form-item required label="驻场工厂">
					<span>{{factoryInfo.factory_name}}</span>
					<a-button class="ml12" type="primary" html-type="submit" @click='visibleFactory=true'>
						选择驻场工厂
					</a-button>


				</a-form-item>
				<a-form-item v-if="form.factory_id" label="工厂ID">
					{{form.factory_id}}
				</a-form-item>
				<a-form-item v-if="form.factory_id" required label="班组">

					<a-checkbox-group v-model="form.shift" name="checkboxgroup" :options="factoryInfo.shift_options"
						@change="onChangeCheckbox" />

				</a-form-item>
				<a-form-item required label="开始驻场时间">
					<a-date-picker style='width:40%' v-model:value="form.start_date" valueFormat="YYYY-MM-DD" />
				</a-form-item>

				<a-form-item  label="结束驻场时间">
					<a-date-picker style='width:40%' v-model:value="form.end_date" valueFormat="YYYY-MM-DD" />
				</a-form-item>

				<div v-if='form.factory_id'>
					<a-divider />
					<h4>当前工厂驻场打卡规则</h4>
					<p>默认跟随当前所选工厂驻场规则，如需修改，需前往驻场规则进行调整</p>
					<div v-if='factoryInfo.peak_frequency'>
						<span class='wTime'>
							旺季
						</span>
						<span>
							每 {{factoryInfo.peak_frequency}} 时打卡 1 次
						</span>
					</div>
					
					<div v-if='factoryInfo.off_frequency'>
						<span class='nowTime'>
						淡季
						</span>
						<span>
							每 {{factoryInfo.off_frequency}} 时打卡 1 次
						</span>
					</div>
				</div>
			</a-form>
			<a-form-item :wrapper-col="{ span: 12, offset: 5 }">
				<a-button type="primary" html-type="submit" @click='handleSubmit'>
					保存
				</a-button>
				<a-button type="defalut" style='margin-left:60px;' @click="$router.back()">返回</a-button>
			</a-form-item>
			</a-form>
		</div>
		<!-- 选择工厂 -->
		<SelectUser @submit="submit_user" :select_type="'radio'" :visible.sync="visible"></SelectUser>
		<LeaderUid @submit="submitLeader" :visible.sync="leaderFactory"></LeaderUid>
		<SelectFactory @submit="submitFactory" :visible.sync="visibleFactory" :select_type="'radio'"></SelectFactory>
	</div>
</template>

<script>
	import SelectFactory from '@/components/select_factory_dispatch'
	import LeaderUid from '@/components/leader_uid'
	import SelectUser from '@/components/SelectUser'

	import Form from "@/components/Form";
	import {
		message
	} from 'ant-design-vue'
	import {
		post_user
	} from '@/api/api'
	import {
		saveRuleInfo,
		getRuleDetail,
		getFactorySelect,
		getFactoryRule,
		addPersonnel,
		personnelDetail,
		editPersonnel
	} from "@/api/dispatch";
	export default {
		components: {
			Form,
			SelectFactory,
			LeaderUid,
			SelectUser
		},
		data() {
			return {
				leaderFactory: false,
				FactorySelectList: [],
				factoryInfo: {},
				night_end_time: '',
				day_start_time: '',
				day_end_time: '',
				night_start_time: '',
				treeData: [],
				rule_user: [],
				treeDataValue: [],
				expand: false,
				loading: true,
				status: false,
				datas: {},
				form: {},
				leader_name: '',
				map: {},
				leader_uid: {},
				visible: false,
				visibleFactory: false,
				select_user: {},


			};
		},
		created() {
			this.$nextTick(() => {
				if (this.$route.query.id) {
					this.edit(this.$route.query)
				}
			})

		},
		methods: {
			onChangeCheckbox(){
				
			},
			submitLeader(e) {

				this.form.leader_uid = e.data.id
				this.leader_name = e.data.username
			},
			submitFactory(e) {
				this.form.factory_id = e.data.factory_id
				getFactoryRule({
					data: {
						factory_id: e.data.factory_id
					}
				}).then(res => {
					this.factoryInfo = res.data
				})
			},
			submit_user({
				data
			}) {
				this.visible = false;
				this.select_user = data;
				this.form.uid = this.select_user.id

			},
			add_user() {
				this.visible = true;
			},
			get_title(e) {
				let map = {
					address_name: e.title,
					longitude: e.point.lng,
					latitude: e.point.lat,
					address: e.address
				};
				this.map = map;
			},

			edit(info) {
				personnelDetail({
					data: {
						id: info.id
					}
				}).then(res => {
					let data = res.data
					this.form = data
					this.form.shift = data.shift.split(',').map(it => {
						return Number(it)
					})
					this.leader_name = data.leader_name
					this.select_user = {
						username: data.username,
						id: data.uid
					}

					this.form.factory_id = data.factory_id
					getFactoryRule({
						data: {
							factory_id: data.factory_id
						}
					}).then(fa => {
						this.factoryInfo = fa.data
						this.factoryInfo.frequency = data.rule_tag

					})


				})
			},
			handleSubmit(e) {
				let data = JSON.parse(JSON.stringify(this.form));
				if(!data.start_date){
						message.error('请选择驻场开始时间');
						return false
				}
				if(!data.uid){
						message.error('请选择驻场人员');
						return false
				}
				if(!data.factory_id){
						message.error('请选择驻场工厂');
						return false
				}
				if(!data.leader_uid){
						message.error('请选择分管领导');
						return false
				}
				
				if(this.$route.query.id){
					editPersonnel({
						data: {
							...data,
							shift: data.shift.join(',')
						},
						info: true,
					}).then(res => {
						this.$router.back()
					})
				}else{
					addPersonnel({
						data: {
							...data,
							shift: data.shift.join(',')
						},
						info: true,
					}).then(res => {
						this.$router.back()
					})
				}
				
			},

		}
	};
</script>
<style lang="less" scoped>
	.map_select {
		position: relative;
		margin: 0px 10%;
		border: 1px solid #eee;
		padding: 16px;
		border-radius: 8px;

		.serach_input {
			position: absolute;
			top: 20px;
			left: 20px;
		}
	}

	ul {
		padding: 0;
	}

	li {
		display: block;
		list-style: none;
		display: flex;

		span {
			padding-right: 10px;

			display: inline-block;
		}
	}

	.avatar-uploader>.ant-upload {
		width: 128px;
		height: 128px;
	}

	.ant-upload-select-picture-card i {
		font-size: 32px;
		color: #999;
	}

	.ant-upload-select-picture-card .ant-upload-text {
		margin-top: 8px;
		color: #666;
	}

	.spin-content {
		border: 1px solid #91d5ff;
		background-color: #e6f7ff;
		padding: 30px;
	}

	.distributor {
		width: 60%;
		margin-left: 1.5%;
		padding: 5px 10px;
		padding-bottom: 10px;
	}

	.distributor_box {
		background-color: rgba(250, 250, 250, 1);
		margin-left: 14%;
		padding-bottom: 20px;

		.title {
			margin-left: 24px;
		}

		/deep/.ant-col-5 {
			width: 7%;
		}
	}

	.page_content .ant-col-19 {
		width: 34.166667% !important;
	}

	/deep/ .ant-input-affix-wrapper {
		.ant-input:not(:last-child) {
			padding-right: 45px;
		}
	}

	/deep/ .ant-alert-message {
		color: #1890ff;
	}


	/deep/ .ant-alert-icon {
		top: 10px;
	}

	.flex_box {
		display: flex;

		div {
			flex: 1
		}
	}

	.ml12 {
		margin-left: 8px;
	}

	.wTime {
		width: 140px;
		height: 40px;
		line-height: 40px;
		background: #E9FFE0;
		color: #246F0A;
		text-align: center;
		margin-bottom: 8px;
		display: inline-block;
	}

	.nowTime {
		width: 140px;
		height: 40px;
		display: inline-block;
		line-height: 40px;
		background: #FDF6EA;
		color: #B97104;
		text-align: center;
	}

	.can {
		display: inline-block;
		width: 100px;
		height: 36px;
		line-height: 36px;
		background: #E9FFE0;
		color: #246F0A;
		text-align: center;
		margin-bottom: 8px;
	}

	.nocan {
		width: 100px;
		height: 36px;
		line-height: 36px;
		background: #FCE6E3;
		color: #F93317;
		text-align: center;
	}

	.red {
		color: #F93317;
	}

	.flex_box {
		display: flex;
	}
</style>